import React, { useEffect, useRef, useState } from 'react';
import './aboutUs.scss';
import photo from '../../../media/img/companyInfo/nosotros_hero.jpg';

const wonderalyInfo = [
  {
    id: 1,
    numeroFinal: 12,
    description: 'Producciones asesoradas',
  },
  {
    id: 2,
    numeroFinal: 8,
    description: 'Expertos en neuropsicología',
  },
  {
    id: 3,
    numeroFinal: 3,
    description: 'Proyectos activos',
  },
  {
    id: 4,
    numeroFinal: 5,
    description: 'Años de investigación',
  },
];

const AboutUs = () => {


  const [produciones, setProduciones] = useState(0);
  const [expertos, setExpertos] = useState(0);
  const [proyectos, setProyectos] = useState(0);
  const [anos, setAnos] = useState(0);

  const animateCounter = (setter, target) => {
    const duration = 2000;
    const steps = 50;
    const increment = target / steps;
    let current = 0;

    const timer = setInterval(() => {
      current += increment;
      if (current >= target) {
        current = target;
        clearInterval(timer);
      }
      setter(Math.round(current));
    }, duration / steps);
  };

  useEffect(() => {
    animateCounter(setProduciones, wonderalyInfo[0].numeroFinal);
    animateCounter(setExpertos, wonderalyInfo[1].numeroFinal);
    animateCounter(setProyectos, wonderalyInfo[2].numeroFinal);
    animateCounter(setAnos, wonderalyInfo[3].numeroFinal);
  }, []);

  const counterValues = [produciones, expertos, proyectos, anos];

  const lineRefs = useRef([]);

  useEffect(() => {
    const observerOptions = {
      threshold: 0.2,
      rootMargin: '0px 0px 0px 0px',
    };

    const lineObservers = lineRefs.current.map((lineRef) => {
      if (!lineRef) return null;

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('content__title-line--visible');
            observer.unobserve(entry.target);
          }
        });
      }, observerOptions);

      observer.observe(lineRef);
      return observer;
    });

    return () => {
      lineObservers.forEach((obs) => obs?.disconnect());
    };
  }, []);

  return (
    <div className="companyInfo__aboutUs">
      <section className="aboutUs">
        <div className="aboutUs__imageContainer">
          <img
            src={photo}
            alt="Wonderaly Innovations"
            className="aboutUs__image"
          />
        </div>
        <div className="aboutUs__lineatop"></div>
        <div className="aboutUs__lineabottom"></div>
        <div className="aboutUs__header">
          <h1 className="header-title__main-page">Sobre Nosotros</h1>
          <div
            ref={(el) => (lineRefs.current[0] = el)}
            className="content__title-line"
          />
          <p className="header-subtitle__main-page">
            Neuropsicología aplicada a las artes y la producción audiovisual
          </p>
        </div>
        <div className="aboutUs__container">
          {wonderalyInfo.map((info, index) => (
            <div key={info.id} className="aboutUs__card">
              <div className="aboutUs__number">{counterValues[index]}</div>
              <p className="aboutUs__description content__text-paragrah-title-backgroundDark">
                {info.description}
              </p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default AboutUs;
